import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Shared/Models/CustomFilterModels";

export enum AnnotationFilter {
    All
}

export enum AnnotationOrder {
    None
}

export interface IAnnotationStyleModel {
    text?: { fillColorHex?: string; size?: number; font?: string; weight?: string; };
    stroke?: { colorHex?: string; width?: number; endCap?: string; weight?: string; };
    fill?: { colorHex?: string; };
}

